import { render, staticRenderFns } from "./ReferrerTypeCard.vue?vue&type=template&id=8de2c228"
import script from "./ReferrerTypeCard.vue?vue&type=script&lang=js"
export * from "./ReferrerTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports